/**
 * Potency Badges Count-Up Animation
 * Animates percentage numbers from 0 to the target value
 */

class PotencyBadgeCounter {
  constructor(element, duration) {
    this.element = element;
    this.target = parseFloat(element.dataset.target) || 0;
    this.current = 0;
    this.duration = duration || 1500; // Animation duration in ms
    this.hasAnimated = false;
    
    // Start animation when badges come into view
    this.observeVisibility();
  }

  observeVisibility() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.hasAnimated) {
          this.animate();
          this.hasAnimated = true;
        }
      });
    }, {
      threshold: 0.5 // Trigger when 50% of element is visible
    });

    observer.observe(this.element);
  }

  animate() {
    const startTime = performance.now();
    const startValue = 0;
    const endValue = this.target;
    
    const step = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / this.duration, 1);
      
      // Easing function (easeOutCubic)
      const eased = 1 - Math.pow(1 - progress, 3);
      
      const currentValue = startValue + (endValue - startValue) * eased;
      
      // Format the number (show decimal if target has decimal)
      const formattedValue = this.target % 1 === 0 
        ? Math.floor(currentValue)
        : currentValue.toFixed(1);
      
      this.element.textContent = formattedValue;
      
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        // Ensure we end on the exact target value
        this.element.textContent = this.target % 1 === 0 
          ? this.target 
          : this.target.toFixed(1);
      }
    };
    
    requestAnimationFrame(step);
  }
}

// Initialize all potency badge counters when DOM is ready
function initPotencyBadges() {
  const containers = document.querySelectorAll('.product-potency-badges');
  containers.forEach(container => {
    const duration = parseInt(container.dataset.animationDuration) || 1500;
    const badges = container.querySelectorAll('.potency-badge__percentage[data-target]');
    badges.forEach(badge => {
      new PotencyBadgeCounter(badge, duration);
    });
  });
}

// Run on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPotencyBadges);
} else {
  initPotencyBadges();
}

// Also run when product form updates (for variant changes if needed)
document.addEventListener('variant:change', initPotencyBadges);

